<template>
  <kst-section collapsible collapsed info-mode
    :help-collapsed="sectionHelp"
    :help="sectionHelp"
    :title="sectionTitle"
  >
    <kst-number-with-date view-mode
      :catalog="Catalog"
      :data="details"
      dateField="SalesOrderDate"
      numberField="SOID"
    />
  </kst-section>
</template>

<script>
import Catalog from "../DlvCatalog.js";
import Info from "../DlvInfo.js";
import Model from "../DlvModel.js";

export default {
  props: {
    details: Object
  },
  data: () => ({
    Catalog: Catalog
  }),
  computed: {
    sectionHelp() {
      return Model.getInvoiceSectionHelp(this.details);
    },
    sectionTitle() {
      return Info.Section.Invoice.Title;
    }
  }
}
</script>